import { ChangeEvent, FocusEventHandler, ReactNode, forwardRef } from 'react';

import { Box, FormControl, FormHelperText, InputAdornment, SxProps, TextField } from '@mui/material';

import './TextInput.scss';

interface TextInputI {
  type?: string;
  size?: 'small' | 'medium';
  label?: string;
  placeholder?: string;
  name?: string;
  value?: any;
  defaultValue?: any;
  helperText?: string | null;
  error?: boolean;
  disabled?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
  required?: boolean;
  multiline?: boolean;
  rows?: number | string;
  minRows?: number | string;
  maxRows?: number | string;
  precontent?: string | ReactNode;
  postcontent?: string | ReactNode;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  autoComplete?: string;
  sx?: SxProps;
  labelSx?: SxProps;
  preContentSx?: SxProps;
  postContentSx?: SxProps;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  autoFocus?: boolean;
  readOnly?: boolean;
  inputRef?: any;
}

export const TextInput = forwardRef<HTMLDivElement, TextInputI>((props, ref) => {
  const {
    type,
    size,
    label,
    placeholder,
    name,
    value,
    defaultValue,
    helperText,
    error,
    variant,
    disabled,
    required,
    multiline,
    rows,
    minRows,
    maxRows,
    precontent,
    postcontent,
    onChange,
    autoComplete,
    sx,
    labelSx,
    preContentSx,
    postContentSx,
    onFocus,
    onBlur,
    inputRef,
    autoFocus,
    readOnly,
  } = props;
  return (
    <FormControl className='FormControlComponent'>
      {label && (
        <Box className='InputLabelComponent' sx={labelSx}>
          {label}
        </Box>
      )}
      <TextField
        className='TextFieldComponent'
        {...props}
        required={required}
        ref={ref}
        autoComplete={autoComplete}
        sx={sx}
        fullWidth
        hiddenLabel
        label=''
        id={`text-input-${name || 'box'}`}
        type={type || 'text'}
        size={size || 'small'}
        variant={variant || 'filled'}
        placeholder={placeholder}
        name={name}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        minRows={minRows}
        maxRows={maxRows}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={autoFocus}
        InputProps={{
          disableUnderline: true,
          readOnly: readOnly,
          startAdornment: precontent ? (
            <InputAdornment position='start' sx={preContentSx}>
              {precontent}
            </InputAdornment>
          ) : null,
          endAdornment: postcontent ? (
            <InputAdornment position='end' sx={postContentSx}>
              {postcontent}
            </InputAdornment>
          ) : null,
        }}
        inputRef={inputRef}
        helperText={null}
      />
      {error && helperText && (
        <FormHelperText className='HelperText'>
          <span className='Danger'>{helperText}</span>
        </FormHelperText>
      )}
    </FormControl>
  );
});
export { TextField };